module.exports = __webpack_public_path__ + "bz.svg?ca77ff979e4e7e33ff61bf2996c3a7b1";